export const 
  COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException",
  COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION = "PasswordResetRequiredException",
  COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION = "UserNotConfirmedException",
  COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION =  "UserNotFoundException",
  COGNITO_ERROR_CODE_MISMATCH_EXCEPTION = "CodeMismatchException",
  COGNITO_ERROR_EXPIRED_CODE_EXCEPTION = "ExpiredCodeException",

  PATREG_DUPLICATE_MOBILE = 'W(250xPR001)',
  PATREG_DUPLICATE_EMAIL = 'W(250xPR006)',
  PATREG_INVALID_EMAIL = 'W(250xPR014)',
  PATREG_INVALID_MOBILE_NUMBER = 'W(250xPR015)',
  PATREG_INVALID_COUNTRY = 'W(250xPR017)',
  PATREG_INVALID_PROVINCE = 'W(250xPR018)',
  PATREG_INVALID_CITY = 'W(250xPR019)',
  PATREG_INVALID_BARANGAY = 'W(250xPR020)',
  MISSING_PARAMETER = 'W(250x004)'
;